import { render } from "./step1.vue?vue&type=template&id=466b453c&scoped=true&ts=true"
import script from "./step1.vue?vue&type=script&lang=ts"
export * from "./step1.vue?vue&type=script&lang=ts"

import "./step1.vue?vue&type=style&index=0&id=466b453c&lang=sass&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466b453c"]])

export default __exports__